export const NAV_PANEL_WIDTH = 260;
export const DEFAULT_PAGE_TITLE = 'Dashboard';
